import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { DocumentPostStatusEnum } from "src/enums/DocumentPostStatusEnum";
import { StockTakingsDetail } from "src/components/Pages/Documents/Warehouse/StockTakings/components/StockTakingsDetail";
import StockTakingsList from "src/components/Pages/Documents/Warehouse/StockTakings/components/StockTakingsList";
import { NFLookupStockTakings } from "src/components/Shared/NewForms/NFLookupStockTakings";
import { StockTakingsDto } from "src/components/Pages/Documents/Warehouse/StockTakings/dtos/StockTakingsDto";
import { StockTakingsService } from "src/services/documents/StockTakingsService";

export const StockTakings: IAppEntity = {
  entityType: "document",
  title: "Stock Takings",
  pluralTitle: "Stock Takings",
  apiUrl: "StockTakings",
  apiEnum: ReferenceTypes.DocumentStocktaking,
  getDetailView: (id?: string) => {
    return React.createElement(StockTakingsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(StockTakingsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupStockTakings, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new StockTakingsService("StockTakings"),
  getEmptyModel: () => {
    const model: StockTakingsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: DocumentPostStatusEnum.Draft,
      documentDate: new Date(),
      createdDate: new Date(),
      stocktakingGoods: []
    };
    return model;
  }
};
